import { render, staticRenderFns } from "./editResourceStore.vue?vue&type=template&id=b54f0476&scoped=true"
import script from "./editResourceStore.vue?vue&type=script&lang=js"
export * from "./editResourceStore.vue?vue&type=script&lang=js"
import style0 from "./editResourceStore.vue?vue&type=style&index=0&id=b54f0476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54f0476",
  null
  
)

export default component.exports